import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDiningIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 27,
	height: 20,
	viewBox: "0 0 27 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9954 6.58008C17.3837 6.58008 20.1313 9.25673 20.1313 12.5576H7.85938C7.85938 9.25673 10.607 6.58008 13.9954 6.58008Z",
			stroke: "#610085",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5311 12.5566H6.47266V14.9401H21.5311V12.5566Z",
			stroke: "#610085",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9964 6.57898C14.7042 6.57898 15.278 6.02002 15.278 5.3305C15.278 4.64099 14.7042 4.08203 13.9964 4.08203C13.2886 4.08203 12.7148 4.64099 12.7148 5.3305C12.7148 6.02002 13.2886 6.57898 13.9964 6.57898Z",
			stroke: "#610085",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.67518 0.5C4.67518 0.5 6.45485 8.54763 2.80447 8.54763C-0.845915 8.54763 0.933749 0.5 0.933749 0.5",
			stroke: "#610085",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.80469 0.5V4.52382",
			stroke: "#610085",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.55622 8.54688L1.46358 17.3525C1.36425 18.1266 1.98507 18.804 2.78799 18.804C3.58263 18.804 4.20344 18.1266 4.11239 17.3606L3.06114 8.55494",
			stroke: "#610085",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.4726 9.03952L23.4296 17.4178C23.3385 18.1516 23.9262 18.7967 24.6878 18.7967C25.4493 18.7967 26.037 18.1516 25.946 17.4178V0.5H25.9542C24.4477 0.5 23.2227 1.69344 23.2227 3.16104V7.19292C23.2227 7.9993 23.711 8.72503 24.4643 9.03952H24.4726Z",
			stroke: "#610085",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgDiningIcon;
